// What the backend reports after a Settings save or remove: one entry per
// thing it put into effect. `needs_attention` means the change was saved but
// could not be applied live; `detail` says why, in plain words.
export interface AppliedEntry {
  path: string;
  result: "applied" | "needs_attention";
  detail?: string;
}

export interface ConfigSaveResponse {
  section?: string;
  value?: unknown;
  applied?: AppliedEntry[];
}

export interface SaveMessage {
  kind: "ok" | "error";
  text: string;
}

// The needs-attention details, verbatim, joined into one line ("" when
// everything was applied or the backend sent no list).
export function needsAttentionText(applied: AppliedEntry[] | null | undefined): string {
  if (!Array.isArray(applied)) return "";
  return applied
    .filter((a) => a && a.result === "needs_attention")
    .map((a) => (a.detail && a.detail.trim() ? a.detail : a.path))
    .join(" ");
}

// The save result line: "Applied", or the needs-attention details.
export function saveResultMessage(applied: AppliedEntry[] | null | undefined): SaveMessage {
  const attention = needsAttentionText(applied);
  return attention ? { kind: "error", text: attention } : { kind: "ok", text: "Applied" };
}
